enum ResponseCode {

  SUCCESS = 200,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND_DATA = 404,
  UNKNOWN = 999,

  ERROR_BLUETOOTH_DOWNLOAD_IMAGE_FAILED = 2011,

  ERROR_FORCE_LOGOUT = 1000,
  ERROR_USER_REGISTER = 1001,
  ERROR_USER_NO_EXIST = 1002,
  ERROR_DATA_ADD = 1003,
  ERROR_DATA_EDIT = 1004,
  ERROR_DATA_DELETE = 1005,
  ERROR_DATA_REGISTER = 1006,

  ERROR_VERIFY_PARAMETER = 1101,
  ERROR_VERIFY_PERMISSION = 1102,
  ERROR_UPLOAD_TEMPLATE_FAILED = 1011,
}

export default ResponseCode;
